import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useAuth, useApiPatch } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";

import UserForm from './UserForm';

export default function UpdateUser({ show, onHide, userDetails, handleAct}) {
    console.log('userDetails', userDetails);
    const recordId = userDetails.id;
    const [submitted, setSubmitted] = useState(false);
    const [customerror, setCustomerror] = useState('');
    const { authToken } = useAuth();
  
    const { patchData, loading: updateLoading } = useApiPatch(`users`, authToken);
  
  
    const handleSubmit = async (formData) => {
        setSubmitted(false);
        setCustomerror('');
      if (formData && Object.keys(formData).length > 0) {
        formData.id = recordId;
        const payload = JSON.stringify(formData);
        const { result, error } = await patchData(payload);
  
        if (result?.data) {
          setSubmitted(true);
          setCustomerror('');
          setTimeout(() => {
            handleAct();
            setSubmitted(false);
          }, 300);
        } else {
          setCustomerror(error || 'Failed to update user');
        }
      }
    };

    const hndlCustomClose = () => {
          setCustomerror('');
          setSubmitted(false);
          onHide();
    }

  return (<Modal role="dialog" className='useredit-form-popup' dialogClassName="right-slide-modal" size='lg' show={show} backdrop centered={false} >
            <div className="modal-content">
              <button type="button" onClick={hndlCustomClose} className="btn-close position-absolute end-0 top-0 m-3"></button>
              <ModalHeader>Update Employee</ModalHeader>
                  <ModalBody>
  
                    <div className="useredit-page">
                      {submitted && <SuccessToolbar message="🎉 Employee have been updated successfully." />}
                      {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
                      <UserForm
                        mode="edit"
                        onSubmit={handleSubmit}
                        loading={updateLoading}
                        initialData={userDetails}
                      />
                    </div>
          
                </ModalBody>
             </div>
           </Modal>);
}